import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {FillableFormField, FillableFormFieldFilter, FillableFormFieldInput} from './fillable-form-field.model';

export const loadFillableFormFields = createAction(
  '[FillableFormField/API] Load FillableFormFields',
  props<{ fillableFormFields: FillableFormField[] }>()
);

export const addFillableFormField = createAction(
  '[FillableFormField/API] Add FillableFormField',
  props<{ fillableFormField: FillableFormField }>()
);

export const upsertFillableFormField = createAction(
  '[FillableFormField/API] Upsert FillableFormField',
  props<{ fillableFormField: FillableFormField }>()
);

export const addFillableFormFields = createAction(
  '[FillableFormField/API] Add FillableFormFields',
  props<{ fillableFormFields: FillableFormField[] }>()
);

export const upsertFillableFormFields = createAction(
  '[FillableFormField/API] Upsert FillableFormFields',
  props<{ fillableFormFields: FillableFormField[] }>()
);

export const updateFillableFormField = createAction(
  '[FillableFormField/API] Update FillableFormField',
  props<{ fillableFormField: Update<FillableFormField> }>()
);

export const updateFillableFormFields = createAction(
  '[FillableFormField/API] Update FillableFormFields',
  props<{ fillableFormFields: Update<FillableFormField>[] }>()
);

export const deleteFillableFormField = createAction(
  '[FillableFormField/API] Delete FillableFormField',
  props<{ id: string }>()
);

export const deleteFillableFormFields = createAction(
  '[FillableFormField/API] Delete FillableFormFields',
  props<{ ids: string[] }>()
);

export const clearFillableFormFields = createAction(
  '[FillableFormField/API] Clear FillableFormFields'
);

// CUSTOM
export const createFillableFormFields = createAction(
  '[FillableFormField/API] create FillableFormFields',
  props<{ input: FillableFormFieldInput }>()
);


export const editFillableFormFields = createAction(
  '[FillableFormField/API] edit FillableFormFields',
  props<{ input: FillableFormFieldInput }>()
);


export const getFillableFormFields = createAction(
  '[FillableFormField/API] get FillableFormFields',
  props<{ filtering: FillableFormFieldFilter }>()
);


export const removeFillableFormFields = createAction(
  '[FillableFormField/API] remove FillableFormFields',
  props<{ fieldUid: string, id: string }>()
);

// CITIZEN
export const citizenGetFormFields = createAction(
  '[FillableFormField/API] citizen get FillableFormFields',
  props<{ formUniqueId: string }>()
);
